<template>
<svg data-svg-lvl-3="flyleaffront-block-flyleaffront" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><mask id="lff-m-f" x="0" y="0" width="500" height="430" fill="#ffffff"><polygon  points="114.68 200.12 114.68 294.93 114.68 294.93 114.68 389.73 399.36 389.73 399.36 294.93 399.36 294.93 399.36 200.12 114.68 200.12"/></mask></defs><g id="Форзац"> <polygon  :style="{ fill: params.flyleaffrontColor }"  class="lff-c-3" points="114.68 200.12 114.68 294.93 114.68 294.93 114.68 389.73 399.36 389.73 399.36 294.93 399.36 294.93 399.36 200.12 114.68 200.12"/> <image v-if="params.flyleaffrontImage" preserveAspectRatio="xMidYMid slice" width="500" height="430" :href="params.flyleaffrontImage" mask="url(#lff-m-f)" /> </g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lff-c-1{opacity:0.3;}.lff-c-2{fill:#64ff00;}.lff-c-3{fill:#f4e8ce;}</style>

